/*@ngInject*/
const DataSetEditorController = function ($scope, $stateParams, configurationConstant, dataSetType, dataSetEditorModel) {

    // UMS-20495 workaround
    var dataSetName;
    try {
        dataSetName = decodeURIComponent($stateParams.dataSetName);
    }
    catch (exception){
        dataSetName = $stateParams.dataSetName;
    }

    $scope.viewModel = {
        displayNavTabs: parseInt($stateParams.type) !== dataSetType.STATIC && parseInt($stateParams.type) !== dataSetType.REPEATING_FORM,
        dataSetName: dataSetName
    };

    function init() {
        dataSetEditorModel.buildDataSet($scope.viewModel.dataSetName);
    }

    $scope.$on('$destroy', function () {
        dataSetEditorModel.reset($scope.viewModel.dataSetName);
    });

    $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
        $scope.viewModel.dataSetName = dataSetName;
    });

    init();
};

angular.module('ums.configuration')
    .controller('dataSetEditorController', DataSetEditorController);
